import React, { Component } from 'react'
import  { connect } from 'react-redux'
import { detectar_mobile } from '../../utils'

import { CheckCircleOutline } from '@material-ui/icons';

import  {
    deslogar
} from '../../actions'

class Conclusao extends Component {
    constructor(){
        super()
    }

    render(){
        return(
            <div className="" style={customStyles.container}>
                <div className="" style={customStyles.grid}>
                    <div className="" style={{display:'grid',justifyItems:"center"}}>
                        <CheckCircleOutline className="text-success" style={{color:'',fontSize:100}} />
                        <div className="d-flex align-items-center text-center">
                            {/* <img src="/assets/imagem/icon-ok.png" width="60" height="70" style={{margin:'1.5%'}}/> */}
                            <div style={{display:'grid',alignContent:'flex-end',padding:'1%'}}>
                                <p className="text-success h4 font-weigth-normal" style={{fontWeight:500}}> 
                                    Assinatura efetuada com sucesso
                                </p>
                                <p style={{fontSize:16, color: '#4d4d4d'}}>
                                    Você receberá um e-mail com o documento assinado
                                </p>
                            </div>        
                        </div>
                        {/* <img src="/assets/imagem/icon-assinatura.png"  width="60" style={{margin:'1.5%'}}/> */}
                    </div>
                    <button style={customStyles.button} className="btn btn-success" onClick={ () => this.props.deslogar()}>
                        Concluído
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({  }) => {
    return {
    }
}

export default connect(mapStateToProps, {
    deslogar
})(Conclusao); 

const customStyles = {
    container: {
        width:'100%',
        height:'100%',
        display:'grid',
        alignItems: 'center',
        justifyContent: 'center',
        background:'rgba(233, 236, 239, 0.15)'
    },
    button:{
        height:54
    },
    grid:{
        display:'grid',
        height: detectar_mobile() ? '100%' : '60%',
        alignItems:'end',
        borderRadius: '8px'
    }
}